<div class="sidebar-wrapper">
  <!-- Intestazione Indici presenti con pulsante Aggiungi Indice -->
  <div class="sidebar-header">
    <div class="title-row">
      <span class="material-symbols-outlined title-icon">database</span>
      <span class="title-text">Indici presenti</span>
    </div>
    <button class="btn-add-index" (click)="openNewIndexModal()" title="Crea un nuovo indice">
      <span class="material-symbols-outlined">add</span>
      <span>Aggiungi indice</span>
    </button>
  </div>

  <!-- Lista Indici con sottomenu Documenti e Siti web -->
  <nav class="sidebar-nav">
    @if (isLoading()) {
      <div class="sidebar-message">
        <span class="material-symbols-outlined spin">sync</span>
        <span>Caricamento indici...</span>
      </div>
    } @else if (indexes().length === 0) {
      <div class="sidebar-message empty">
        <span class="material-symbols-outlined">folder_off</span>
        <span>Nessun indice presente</span>
      </div>
    } @else {
      @for (idx of indexes(); track idx._id) {
        <div class="index-group" [class.expanded]="expandedIndex() === idx.name">
          <div class="index-header-row" [class.active]="expandedIndex() === idx.name">
            <button 
              type="button"
              class="index-toggle-btn"
              (click)="toggleIndex(idx.name)">
              <span class="material-symbols-outlined expand-icon">
                {{ expandedIndex() === idx.name ? 'expand_more' : 'chevron_right' }}
              </span>
              <span class="material-symbols-outlined index-icon">database</span>
              <span class="index-name" [title]="idx.name">{{ idx.name }}</span>
            </button>
            <button 
              type="button"
              class="btn-delete-index" 
              title="Elimina indice" 
              (click)="openDeleteModal($event, idx)">
              <span class="material-symbols-outlined">delete</span>
            </button>
          </div>

          @if (expandedIndex() === idx.name) {
            <div class="sub-menu-container">
              <button 
                class="sub-item" 
                [class.active]="expandedIndex() === idx.name && selectedSubView() === 'documents'"
                (click)="selectSubView(idx.name, 'documents')">
                <span class="material-symbols-outlined">description</span>
                <span>Documenti</span>
              </button>
              <button 
                class="sub-item" 
                [class.active]="expandedIndex() === idx.name && selectedSubView() === 'web-sites'"
                (click)="selectSubView(idx.name, 'web-sites')">
                <span class="material-symbols-outlined">language</span>
                <span>Siti web</span>
              </button>
            </div>
          }
        </div>
      }
    }
  </nav>
</div>